/**
 * Add a delay before invoking the callback function.
 * @param {func} func The callback function
 * @param {number} wait How long to wait before invoking the function, in ms
 * @returns {void}
 */
let timer;
const debounce = (func, wait = 500) => {
  const debounceFunc = (...args) => {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), wait);
  };
  return debounceFunc();
};

export default debounce;
